import { useState } from "react";
import * as systemUtils from "../../../abstract/controller/utils/systemUtils";
import { AlertErrorFill16 } from "../../../themes/icons/AlertErrorFill16";
import DefaultTooltip from "../tooltips/DefaultTooltip";
import styles from "./IconError.module.scss";

function IconError({ uuid, errors }) {
  const [copied, setCopied] = useState(false);

  const _hasErrors = errors?.length > 0;

  const _isDirect = _hasErrors ? errors?.some((e) => e?.isDirect) : null;
  const _errorMessageDirect = errors
    ?.filter((e) => e?.isDirect)
    ?.map((e) => (
      <li key={e.message}>
        {e.message}
      </li>
    ));
  const _errorMessageIndirect = errors
    ?.filter((e) => !e?.isDirect)
    ?.map((e) => (
      <li key={e.message}>
        {e.name} - {e.message}
      </li>
    ));

  const handleOnClick = () => {
    if (_hasErrors) {
      systemUtils.copyToClipboard(errors?.map((e) => `${e.location}\n${e.message}`).join("\n"));
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, "1000");
    }
  };

  return (
    <>
      <div
        onClick={handleOnClick}
        className={`${styles["icons-error"]} ${_hasErrors ? styles[`icons-error--${_isDirect ? "direct" : "indirect"}`] : ""}`}
        data-tooltip-id={`tooltip-error-${uuid}`}>
        {_hasErrors ? <AlertErrorFill16 /> : <>&nbsp;</>}
      </div>

      {_hasErrors && (
        <DefaultTooltip handle={`tooltip-error-${uuid}`}>
          <div className={styles["tooltip__body"]}>
            {_errorMessageDirect?.length > 0 && (
              <div className={styles["tooltip__list"]}>
                <ul>{_errorMessageDirect}</ul>
              </div>
            )}

            {_errorMessageIndirect?.length > 0 && (
              <div className={styles["tooltip__list"]}>
                Indirect errors:
                <ul>{_errorMessageIndirect}</ul>
              </div>
            )}
            <div className={styles["tooltip__hint"]}>
              {copied ? "Copied to clipboard" : "Click on the icon to copy the error to clipboard"}
            </div>
          </div>
        </DefaultTooltip>
      )}
    </>
  );
}

export default IconError;
